module.exports = "https://www.gc-pro.gnp.com.mx/20dbcd4c9cafdaf4063aaad83de31909.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/estados-cuenta.svg
// module id = 8104
// module chunks = 0